var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{class:[_vm.colorClass,_vm.isActiveClass]},[_vm._v(_vm._s(_vm.$d(new Date(_vm.context), _vm.dateFormat)))])}
var staticRenderFns = []

export { render, staticRenderFns }